/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const LockSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Lock square"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M12 12c.631 0 1.143.498 1.143 1.111v3.333c0 .614-.512 1.112-1.143 1.112s-1.143-.498-1.143-1.112v-3.333c0-.614.512-1.111 1.143-1.111"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M12 2c2.525 0 4.571 1.99 4.571 4.444v1.112c1.894 0 3.429 1.492 3.429 3.333v7.778C20 20.507 18.465 22 16.571 22H7.43C5.535 22 4 20.508 4 18.667v-7.778c0-1.841 1.535-3.333 3.429-3.333V6.444C7.429 3.99 9.475 2 12 2M7.429 9.778c-.632 0-1.143.497-1.143 1.11v7.779c0 .613.511 1.11 1.143 1.11h9.142c.632 0 1.143-.497 1.143-1.11v-7.778c0-.614-.511-1.111-1.143-1.111zM12 4.222c-1.262 0-2.286.995-2.286 2.222v1.112h4.572V6.444c0-1.227-1.024-2.222-2.286-2.222"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const LockSquareIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'lock-square-icon'}
      icon={LockSquare}
      {...props}
      size={size}
    />
  );
};
